import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import twiga from "../../../assets/images/twiga.jpg";
import teraco from "../../../assets/images/teraco.jpg";
import ihub from "../../../assets/images/ihub.jpg";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
  borderRadius: "20px",
};

const objectList = [
  {
    icon: twiga,
    title: "CASE 1: Twiga Foods",
    subtitle:
      "Use Case: Supply chain optimization and digital marketplace use case",
    description:
      "Twiga Foods is a Kenyan based organization that incorporates Google Cloud-based solutions and AI-powered platforms to streamline agricultural supply chains. The use of cloud-based AI platforms has improved Kenya’s and regional agricultural supply chain by leveraging technology to connect smallholder farmers with urban retailers. ",
    link: "/case-study-twiga-foods",
  },
  {
    icon: teraco,
    title: "CASE 2: Teraco Data Environments",
    subtitle: "Use Case for Digital Infrastructure and Data Center Solutions",
    description:
      "Teraco Data Environments is Africa’s largest provider of carrier-neutral colocation and interconnection services. Teraco offers a critical infrastructure platform for improving digital connectivity and fostering data-driven solutions in Africa. Teraco’s ecosystem supports over 22,000 interconnections...",
    link: "/case-study-teraco-data-environments",
  },
  {
    icon: ihub,
    title: "CASE 3: iHub, Kenya",
    subtitle: "Use Case for Digital Infrastructure and Data Center Solutions",
    description:
      "iHub, based in Nairobi, Kenya is a pioneering example of how innovation hubs can transform local economies and address systemic challenges. Since its establishment, iHub has provided vital support to startups, developers, and entrepreneurs through resources such as mentorship, funding opportunities, and tailored programs like coding bootcamps and AI workshops.",
    link: "/case-study-ihub-kenya",
  },
];

const CaseStudies = () => {
  return (
    <Box margin={{ xs: "25% 0% 15% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "0%" }}
        color={"#39484E"}
      >
        Case-Studies of Potential Grantees
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle, description, link } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 4% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "25vh", sm: "220px" }}
                      width={{ xs: "100%", sm: "100%" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"2%"}
                    fontWeight={700}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"4%"}
                    color={"#000"}
                  >
                    {description}
                  </Typography>
                  <Link
                    href={link}
                    paddingTop={{ xs: "6%", sm: "4%" }}
                    underline="hover"
                    sx={{
                      color: "#948979",
                      "&:hover": {
                        color: "#AC7551",
                      },
                    }}
                  >
                    Read More &#10230;
                  </Link>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CaseStudies;
